import React from 'react';

function Chevron(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="9" 
            height="8" 
            viewBox="0 0 9 8" 
            fill="none"
            className={className}
        >
            <path 
                d="M2.7592 0.243947C3.0723 -0.0813155 3.58721 -0.0813155 3.90032 0.243947L7.51595 3.99999L3.90032 7.75603C3.58721 8.08129 3.0723 8.08129 2.7592 7.75603C2.45527 7.44029 2.45527 6.93514 2.7592 6.6194L5.2807 3.99999L2.7592 1.38057C2.45527 1.06483 2.45527 0.559682 2.7592 0.243947Z"
                fill={fill}
            />
        </svg>
    )
};

export default Chevron;